import { Component, Input, OnInit, Optional } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

@Component({
    selector: 'app-dialog-confirm-action',
    templateUrl: './dialog-confirm-action.component.html',
    styleUrls: ['./dialog-confirm-action.component.scss'],
})
export class DialogConfirmActionComponent implements OnInit {
    @Input() message: string;
    @Input() confirmText: string = 'Cancelar Inscrição';
    constructor(@Optional() public nbDialogRef: NbDialogRef<any>) {}

    ngOnInit(): void {}
}
